// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/fonts/iconfont.css'
// import navList from './utils/navList'
import validate from './utils/validate'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import common from './utils/common.js'
// 富文本
import Vue2Editor from "vue2-editor";
import $url from './utils/url.js'

import moment from 'moment'

Vue.use(Vue2Editor);
Vue.use(VueCookies)
Vue.config.productionTip = false
// Vue.prototype.navList = navList
Vue.prototype.validate = validate
Vue.prototype.$axios = axios
Vue.prototype.$common = common
Vue.prototype.$url = $url

Vue.prototype.moment = moment


Vue.$cookies.config(0,null,".zengcaicloud.com")
// 全局获取缓存数据
Vue.prototype.resetSetItem = function (key, newVal) {
    // 创建一个StorageEvent事件
    let newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
        setItem: function (k, val) {
            sessionStorage.setItem(k, val);
            // 初始化创建的事件
            newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
            // 派发对象
            window.dispatchEvent(newStorageEvent)
        }
    }
    return storage.setItem(key, newVal);
}

Vue.use(ElementUI)
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js